export default function BankAccount({ style }) {
  return (
    <span className="comapny-bank-account" style={style}>
      {" "}
      41 1140 2004 0000 3902 7579 5889
    </span>
  );
}
